module.exports = __webpack_public_path__ + "img/9.0c508042.png";